import { translate } from '@jsverse/transloco';
export enum StatusReportSectionStatus {
    NOT_COMPLETED = 'NOT_COMPLETED',
    COMPLETED = 'COMPLETED',
    NA = 'NA',
}

export class StatusReportSectionStatusHelper {
    static getStatusReportSectionStatusString(statusReportSectionStatus: StatusReportSectionStatus): string {
        switch (statusReportSectionStatus) {
            case StatusReportSectionStatus.NOT_COMPLETED:
                return translate('STATUS_REPORT_SECTION_STATUS.NOT_COMPLETED');
            case StatusReportSectionStatus.COMPLETED:
                return translate('STATUS_REPORT_SECTION_STATUS.COMPLETED');
            case StatusReportSectionStatus.NA:
                return translate('STATUS_REPORT_SECTION_STATUS.NOT_APPLICABLE');
            default:
                return statusReportSectionStatus;
        }
    }

    static getStatusReportSectionStatusBadgeIcon(statusReportSectionStatus: StatusReportSectionStatus): string {
        switch (statusReportSectionStatus) {
            case StatusReportSectionStatus.NOT_COMPLETED:
                return 'cancel';
            case StatusReportSectionStatus.COMPLETED:
                return 'check_circle';
            case StatusReportSectionStatus.NA:
                return 'remove_circle_outline';
            default:
                return '';
        }
    }

    static getStatusReportSectionStatusBadgeIconColor(statusReportSectionStatus: StatusReportSectionStatus): string {
        switch (statusReportSectionStatus) {
            case StatusReportSectionStatus.NOT_COMPLETED:
                return 'error';
            case StatusReportSectionStatus.COMPLETED:
                return 'success';
            case StatusReportSectionStatus.NA:
            default:
                return 'neutral';
        }
    }
}
